import Parse from 'services/parse';

export const isLoggedIn = () => {
  const currentUser = Parse.User.current();
  return !!currentUser || true;
};

export const getLoggedInUser = () => {
  return Parse.User.current();
};

export const logout = async() => {
  return Parse.User.logOut();
};

export const login = async(email: string, password: string) => {
  return Parse.User.logIn(email, password);
};
